import { render, staticRenderFns } from "./BaseInputSelectReadOnly.vue?vue&type=template&id=39da0172&scoped=true&"
import script from "./BaseInputSelectReadOnly.vue?vue&type=script&lang=js&"
export * from "./BaseInputSelectReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39da0172",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
